import { Box, Center, Grid, Text } from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import AutoCrop from "App/BsesPoc/components/imageCropping/AutoCrop";
import { useContext, useEffect, useState } from "react";
import { appRequest } from "routes";

const WorkFlowDescCrm = ({
  activePage,
  showError,
  errors,
  values,
  handleChange,
  isDisabled,
  setFieldValue,
  handleLogoChange,
  handleOpenModal,
  loadOptions,
  isLoading,
  type
}: any) => {
  const [costOptions, setCostOptions] = useState<any[]>([]);

  useEffect(() => {
    const fetchCosts = async () => {
      try {
        const response: any = await appRequest("crmCost", "getall", {});
        if (response?.status === "success" && Array.isArray(response.data)) {
          const options = response.data.map((r: any) => ({
            label: r.costCenterInVim || r.costName,
            value: r.costCenterInVim || r.costName,
          }));

          setCostOptions(options);
        }
      } catch (error) {
        console.error("Error fetching costs:", error);
      }
    };

    fetchCosts();
  }, []);

  return (
    <Box display={activePage === 0 ? undefined : "none"}>
      <Grid gap={6} templateColumns={{ md: "1fr 1fr" }}>
        <Box>
          <CustomInput
            label="Search Initiator"
            name="selectedUserProfile"
            type="select-async"
            loadOptions={loadOptions}
            value={values.selectedUserProfile}
            onChange={(e: any) => {
              setFieldValue('selectedUserProfile', e);
              const userName = e?.email || "";
              const userPrefix = userName?.split('@')[0] || "";
              const profileId = e?.profileId || e?.id || "";
              const costName = Array.isArray(values.costs) ? values.costs.map((c: any) => c.value).join("_") : (values.costs?.value || "");
              const joined = [userPrefix, profileId, costName].filter(Boolean).join("-");
              const formattedName = joined ? `${joined}-mkt` : "";
              setFieldValue('workFlowName', formattedName);
            }}
            getOptionLabel={(option: any) => option.email}
            getOptionValue={(option: any) => option.id}
            loading={isLoading}
            placeholder="Search User..."
            disabled={isDisabled}
            isBoxSelect={true}
          />
          <Text fontWeight="600" color="teal.500" mt={2}>{values.workFlowName}</Text>
        </Box>

        <CustomInput
          label="Flow Name"
          name="flowName"
          placeholder="Enter the Flow Name"
          error={errors.flowName}
          value={values.flowName}
          onChange={handleChange}
          showError={showError}
          disabled={isDisabled}
        />
        <CustomInput
          label="Identifier"
          name="identifier"
          error={errors.name}
          value={values.identifier}
          onChange={handleChange}
          showError={showError}
          disabled={true}
        />

        <CustomInput
          label="Add Document Type"
          name="documentType"
          placeholder="Enter the Document type"
          value={values.documentType}
          onChange={handleChange}
          showError={showError}
          disabled={isDisabled}
        />

        <CustomInput
          label="Select Cost Center"
          name="costs"
          type="select"
          placeholder={costOptions.length > 0 ? "Select Cost Center" : "Loading Cost Center..."}
          value={values.costs}
          onChange={(e: any) => {
            setFieldValue('costs', e);

            const userName = values.selectedUserProfile?.email || "";
            const userPrefix = userName?.split('@')[0] || "";
            const profileId = values.selectedUserProfile?.profileId || values.selectedUserProfile?.id || "";
            const base = [userPrefix, profileId].filter(Boolean).join("-");

            const costName = Array.isArray(e) ? e.map((c: any) => c.value).join("_") : (e?.value || "");
            const joined = base && costName ? `${base}-${costName}` : (base || costName);
            const formattedName = joined ? `${joined}-mkt` : "";
            setFieldValue('workFlowName', formattedName);
          }}
          showError={showError}
          disabled={isDisabled}
          getOptionLabel={(option: any) => option.label || (typeof option === 'string' ? option : "")}
          getOptionValue={(option: any) => option.value || (typeof option === 'string' ? option : "")}
          options={costOptions}
          isBoxSelect={true}
          isMulti={type !== 'edit'}
        />
      </Grid>

      <Box display="none">
        <AutoCrop />
      </Box>

      <Grid mt={6}>
        <Center>
          <CustomInput
            type="file"
            name="logo"
            onChange={(e) => handleLogoChange(e, setFieldValue)}
            label="Upload Logo"
            rest={{ accept: "image/*" }}
            disabled={isDisabled}
          />
        </Center>
        {values && (
          <Box onClick={() => handleOpenModal ? handleOpenModal(values.logo) : null}>
            <Text
              textDecoration={"underline"}
              color="blue.400"
              cursor="pointer"
            >
              {values?.logo?.name}
            </Text>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default WorkFlowDescCrm;
